import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginationBaseService } from 'ng-lightquery';
import { DataSource } from '@angular/cdk/collections';
import { GetConversionInfo } from '../generated-client/generated-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConversionInfosService extends PaginationBaseService<GetConversionInfo> implements DataSource<GetConversionInfo> {
  protected http: HttpClient;


  constructor() {
    const http = inject(HttpClient);

    super(http);
    this.http = http;

    this.baseUrl = '/api/conversion-infos';
    this.sort = { propertyName: 'runAtUtc', isDescending: true };
  }

  connect(): Observable<GetConversionInfo[]> {
    return this.paginationResult
      .pipe(map(r => r.data));
  }

  disconnect() { }
}
